import { FC } from "react";
import { IProductFees, ProductFees } from '../product-fees';
import styles from './product-price.module.scss';
import { readablePrice } from "../../helper";


type ProductPrice = {
  productPriceError?: {
    code: string;
  } | null;
  productPrice?: {
    product: {
      amountPerDay?: number;
      amountPerDayReduced?: number;
    };
  } | null;
};

export type ProductPriceProps = IProductFees & {
  productPrice: ProductPrice | undefined;
  selectedRentalStationId: string | undefined;
  hasHiddenPrices: boolean;
  loginHint?: React.ReactNode;
  translations: {
    minRentalDuration?: string;
    pricePerDay: string;
    reducedPricePrefix: string;
    calculationError: string;
  }
}

export const ProductPrice: FC<ProductPriceProps> = ({
  productPrice: price,
  selectedRentalStationId,
  hasHiddenPrices,
  loginHint,
  serviceFees,
  translations
}) => {

  if (!selectedRentalStationId) {
    return null;
  }

  return (
    <div className={styles.priceInfo}>
      {false === hasHiddenPrices && (<ProductFees serviceFees={serviceFees} translations={translations} />)}
      <div className={styles.dailyPrice}>
        {hasHiddenPrices
          ? loginHint
          : price?.productPriceError && price.productPriceError.code === 'CalculationError'
            ? <div className={styles.errorMessage}>{translations.calculationError}</div>
            : (price?.productPrice && (
              <div className={styles.priceWrapper}>
                {((price.productPrice.product.amountPerDay ?? 0) !== (price.productPrice.product.amountPerDayReduced ?? 0)) && (
                  <span className={styles.oldPrice}>{translations.reducedPricePrefix} {readablePrice(price.productPrice.product.amountPerDay ?? 0)} / {translations.pricePerDay}</span>
                )}

                <span className={styles.price}>{readablePrice(price.productPrice.product.amountPerDayReduced ?? 0)} / {translations.pricePerDay}</span>
                {translations?.minRentalDuration && (
                  <span className={styles.minRentalDuration}>
                    {translations.minRentalDuration}
                  </span>
                )}
              </div>
            ))}
      </div>
    </div>
  );
};
